/**
 * Create one supplier portal account.
 */
define('portalUserCreateView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'jquery',
  'app',
  'dialogFormView',
  'template!portalUserCreateTpl'
], function (
  Module,
  Marionette,
  _,
  Backbone,
  $,
  App,
  DialogFormView,
  createTpl
) {
  'use strict';

  Module.exports = DialogFormView.extend({
    template: createTpl,
    className: 'portal-user-create-popup',

    ui: {
      input: '.js-info-input',
      error: '.error-message',
      confirm: '.js-confirm'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    fieldsToValidate: [
      {name: 'email', type: 'required'}
    ],

    initialize: function (options) {
      this.supplierSecId = options.supplierSecId;
      this.model = new Backbone.Model({
        email: '',
        firstName: '',
        lastName: '',
        locale: 'en'
      });
    },

    serializeData: function () {
      var data = this.model.toJSON();
      data.locales = ['en', 'fr', 'nl', 'de', 'es'];
      return data;
    },

    onConfirm: function () {
      if (!this.validate(this.fieldsToValidate)) {
        return;
      }

      this.ui.confirm.prop('disabled', true);
      this.ui.error.text('');

      var payload = _.extend({supplierSecId: this.supplierSecId}, this.model.toJSON());

      $.when(App.request('portal-users:create', payload))
        .done(_.bind(function (response) {
          this.trigger('created', response);
          this.hide();
        }, this))
        .fail(_.bind(function (xhr) {
          this.ui.confirm.prop('disabled', false);
          // 409 is the one failure an operator can act on themselves: the address
          // is already a portal account, probably for another supplier.
          this.ui.error.text(xhr.status === 409 ?
            _.i18n('portalUsers.emailTaken', null, 'That email already has a portal account.') :
            _.i18n('portalUsers.createFailed', null, 'Could not create the account. Try again in a moment.'));
        }, this));
    }
  });
});

